module.exports = __webpack_public_path__ + "static/media/xojane.com_issues_stephanie-cegielski-donald-trump-campaign-defector_plot.9afd63ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/xojane.com_issues_stephanie-cegielski-donald-trump-campaign-defector_plot.png
// module id = 441
// module chunks = 0